import type { Input } from '@builder.io/sdk';

export const contactSideBarFields = [
  {
    name: 'headingText',
    type: 'string',
  },
  {
    name: 'sidebarItems',
    type: 'list',
    subFields: [
      {
        name: 'link',
        type: 'string',
      },
      {
        name: 'text',
        type: 'string',
      },
    ],
  },
  {
    name: 'footerHeader',
    type: 'string',
  },
  {
    name: 'footerText',
    type: 'string',
  },
] as const satisfies DeepReadonly<Input[]>;

export type ContactSidebarProps = GenerateBuilder<typeof contactSideBarFields>;

export const contactSideBarConfig = {
  name: 'Contact Sidebar',
  inputs: contactSideBarFields,
};

export default contactSideBarFields;
